import { AppBar, Container, Grid, IconButton, Menu, MenuItem, Toolbar, Typography } from "@mui/material";
import Logo from "../images/logo-no-background.png"
import { useNavigate } from "react-router-dom";
import useMediaQuery from '@mui/material/useMediaQuery';
import { useState } from "react";


export default function TopMenu(props) {
    let navigate = useNavigate();
    const wide = useMediaQuery('(min-width:900px)');
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
   
    const handleClose = () => {
        setAnchorEl(null);
    };    

    const select = (name) => {
        navigate("/" + name);
        props.setSelected(name);
    };

    const secondaryMenuText = {
        marginBottom: "10px"
    }


    const renderMenu = (
        <Menu
            anchorEl={anchorEl}
            id="account-menu"
            open={open}
            onClose={handleClose}
            onClick={handleClose}>          
        </Menu>
    );

    return (

        <AppBar >
            <Container maxWidth="xl">
                <Toolbar className='toolbar'>
                    <Grid container direction="column">
                        <Grid container direction="row" justifyContent="center">
                            <IconButton color="inherit" onClick={() => navigate("/")}>
                                <img width={wide ? "300px" : "200px"} src={Logo} alt="Logo" />
                            </IconButton>
                            <Grid item >
                                <Grid container justifyContent="center">

                                   


                                    {/*   <MenuItem onClick={() => navigate("/Syndicates")} sx={{ fontSize: "14px" }}>
                                    <ListItemIcon sx={{ color: "inherit" }}>
                                        <ReceiptIcon />
                                    </ListItemIcon>
                                    <ListItemText>Andelsspel</ListItemText>
                                </MenuItem> */}


                                    {/*  <MenuItem onClick={() => navigate("/PoolX")} sx={{ fontSize: "14px" }}>
                                    <ListItemIcon sx={{ color: "inherit" }}>
                                        <GroupsIcon />
                                    </ListItemIcon>
                                    <ListItemText>PoolX</ListItemText>
                                </MenuItem>
 

                                    <MenuItem onClick={() => select("Live")} sx={{ fontSize: "14px" }}>
                                        <ListItemIcon sx={{ color: "inherit" }}>
                                            <BoltIcon />
                                        </ListItemIcon>
                                        <ListItemText>Liverättning</ListItemText>
                                    </MenuItem>
                                    */}
                                  
                                </Grid>
                            </Grid>
                        </Grid>
                        {props.selected === "Blog" &&
                            <Grid container direction="row" justifyContent="center" alignItems="center">
                                <MenuItem onClick={() => navigate("/andelsspel")} sx={secondaryMenuText}>
                                    Poolspel sport
                                </MenuItem>
                                <Typography sx={{ ...{ margin: "0px 20px 0px 20px" }, ...secondaryMenuText }}>|</Typography>
                                <MenuItem onClick={() => navigate("/travsystem")} sx={secondaryMenuText}>
                                    Trav
                                </MenuItem>
                                <Typography sx={{ ...{ margin: "0px 20px 0px 20px" }, ...secondaryMenuText }}>|</Typography>
                                <MenuItem onClick={() => navigate("/sport")} sx={secondaryMenuText}>
                                    Sport
                                </MenuItem>
                            </Grid>
                        }
                        {props.selected === "Andelar" &&
                            <Grid container direction="row" justifyContent="center" alignItems="center">
                                <MenuItem onClick={() => navigate("/andelar_sport")} sx={secondaryMenuText}>
                                    Sport
                                </MenuItem>
                                <Typography sx={{ ...{ margin: "0px 20px 0px 20px" }, ...secondaryMenuText }}>|</Typography>
                                <MenuItem onClick={() => navigate("/andelar_trav")} sx={secondaryMenuText}>
                                    Trav
                                </MenuItem>                                
                            </Grid>
                        }
                    </Grid>
                </Toolbar>
            </Container>
            {renderMenu}
        </AppBar>



    );
}